import React from "react";
import { useTranslationApp } from "../../lib/i18next";
import {
  ADS_META_DESTINATION_TYPE_NONE,
  ADS_META_DESTINATION_TYPE_WEBSITE,
  FIELD_REQUIRED,
} from "../../i18n/keysTranslations";
import i18next from "i18next";
import Select from "../Form/Select";
import {
  ADS_CAMPAIGN_META_DESTINATION_TYPE_NONE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
} from "../../utils/constants";

const options = [
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
    label: ADS_META_DESTINATION_TYPE_WEBSITE,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_NONE_OPTION,
    label: ADS_META_DESTINATION_TYPE_NONE,
  },
];

const SelectDestinationTypeAdMeta = React.forwardRef(
  function SelectDestinationTypeAdMeta(props, ref) {
    const {
      control,
      errors = {},
      rules = {
        required: {
          value: true,
          message: i18next.t(FIELD_REQUIRED),
        },
      },
      name,
      label,
      disabled = false,
      variant = "filled",
      fullWidth,
      placeholder,
      actionsChange = () => {},
      validationChange = () => true,
      sx = {},
    } = props;

    const { t } = useTranslationApp();

    return (
      <Select
        ref={ref}
        label={t(label)}
        disabled={disabled}
        name={name}
        variant={variant}
        options={options}
        fullWidth={fullWidth}
        placeholder={placeholder}
        displayEmpty={placeholder ? true : false}
        showEmptyOption={placeholder ? true : false}
        doTranslate={true}
        control={control}
        errors={errors}
        actionsChange={actionsChange}
        validationChange={validationChange}
        rules={{
          ...rules,
          validate: (value) => {
            if (!options.map((o) => o.value).includes(value)) return t();
          },
        }}
        sx={sx}
      />
    );
  }
);

export default SelectDestinationTypeAdMeta;
